export const homeBoxImgStyle = {
  position: "relative",
  textAlign: "center",
  width: "100%",
  height: { xs: "400px", sm: "500px", md: "309px", lg: "393px", xl: "510px" },
};

export const homeOverlayStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  textAlign: "center",
  padding: "0 10px", // 🔹 Evita que o texto fique colado na borda
};

export const homeFontStyleActionImages = {
  fontSize: { xs: 24, md: 28, lg: 36 },
  color: "#fff",
  fontWeight: "bold",
  textAlign: "center",
  maxWidth: "90%",
};

export const homeButtonContainerStyle = {
  position: "absolute",
  bottom: "10%", // 🔹 Mantém o botão fixo na parte inferior da imagem
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  width: "100%",
};

export const homeOutlinedButtonStyle = {
  borderRadius: 0,
  borderWidth: 3,
  color: "white",
  borderColor: "white",
  backgroundColor: "transparent",
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: "bold",
  "&:hover": {
    color: "black",
    backgroundColor: "white",
    borderColor: "#ffffff",
  },
};

// **Correções no Estilo**
export const homeButtonStyle = {
    color: 'white',
    fontSize: 25,
    fontFamily: 'Helvetica,Arial,Verdana,sans-serif',
    fontWeight: 'bold',
    textTransform: 'none',
    backgroundColor: 'transparent',
    '&:hover': {
        color: 'white',
        backgroundColor: 'transparent',
        '&:after': {
        backgroundColor: 'yellow',
        }
    },
    '&:active': {
        backgroundColor: 'transparent',
        '&::after': {
          backgroundColor: 'transparent',
        },
    },
    '&:focus': {
        outline: 'none',
    },
    boxShadow: 'none',
    '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 15,
        left: 18,
        width: '62%',
        height: '2px',
        backgroundColor: 'white',
        transition: 'background-color 0.3s ease',
    }
};

export const homeTextShadowStyle = { textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)" };

export const homeDescriptionStyle = {
  fontSize: { xs: 14, sm: 18, md: 18, lg: 18, xl: 18 },
  color: "white",
  textAlign: "center",
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
};